import styled from 'styled-components'
import * as S from 'components/templates/styled'
import { theme } from 'styles/theme'

import { getSize } from 'utils'
import { Decoration } from '../components/BaseLayout/styled'

export const Container = styled(S.Container)`
  .background-image,
  .background-video {
    opacity: 1;
  }
`

export const TextBlock = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${getSize(1152)};
  box-sizing: border-box;
  color: ${theme.colors.white};
  text-align: center;

  font-family: 'Poppins';
  font-weight: 700;
  font-size: ${getSize(56)};
  line-height: ${getSize(66)};
  padding: ${getSize(60)} ${getSize(40)} ${getSize(80)};
  .title {
    text-transform: uppercase;
    color: ${theme.colors.white};
    margin-top: ${getSize(10)};
  }
  ${Decoration} {
    background-color: ${theme.colors.white};
  }

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 11;
    -webkit-box-orient: vertical;
  }

  @media (max-aspect-ratio: 1/1) {
    width: ${getSize(850)};
  }
`
